<template>
    <div class="investmentClues">
        <leftnav class="fl" mkcode="C"
            :itemcode="(curWebsite.type == 5 || curWebsite.type == 6) ? 'C-QYTZPH' : 'C-GDXSTJ'"></leftnav>
        <div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
            <govheader></govheader>
            <el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
                <freeUserTips :type="4" :bgtype="0"></freeUserTips>
            </el-dialog>
            <div class="index_left_centerpage">
                <!-- 头部盒子开始 -->
                <div class="whitebox right_topbox">
                    <div class="right_boxtitle">
                        <span class="fl right_title">企业选址逻辑</span>
                    </div>
                    <!-- 筛选项开始 -->
                    <div class="opport-screen-list1">
                        <div class="spage-searchbox ">
                            <ClueNav tabCode="qyxz"></ClueNav>
                            <dl class="opport-screen bdbe">
                                <dt class="fl">战略态势</dt>
                                <dd class="fl">
                                    <span :class="strategy == '' ? 'a-screen current' : 'a-screen'"
                                        @click="fillter('', 'strategy')">全部</span>
                                    <span v-for="(list, i) in strategyList" :key="i" @click="fillter(list.type, 'strategy')"
                                        :class="strategy == list.type ? 'a-screen current' : 'a-screen'">{{ list.name
                                        }}</span>
                                </dd>
                            </dl>
                            <dl class="opport-screen bdbe">
                                <dt class="fl">选址逻辑</dt>
                                <dd class="fl">
                                    <span :class="site == '' ? 'a-screen current' : 'a-screen'"
                                    @click="fillter('', 'site')">全部</span>
                                    <span v-for="(list, i) in siteList" :key="i" @click="fillter(list.type, 'site')"
                                        :class="site == list.type ? 'a-screen current' : 'a-screen'">{{ list.name
                                        }}</span>
                                </dd>
                            </dl>
                            <dl class="opport-screen bdbe">
                                <dt class="fl">经营信息</dt>
                                <dd class="fl">
                                    <span :class="operate == '' ? 'a-screen current' : 'a-screen'"
                                    @click="fillter('', 'operate')">全部</span>
                                    <span v-for="(list, i) in operateList" :key="i" @click="fillter(list.type, 'operate')"
                                        :class="operate == list.type ? 'a-screen current' : 'a-screen'">{{ list.name
                                        }}</span>
                                </dd>
                            </dl>
                        </div>
                    </div>
                    <!-- 筛选项结束 -->
                </div>
                <!-- 头部盒子结束 -->
                <!-- 表格内容开始 -->
                <div class="whitebox">
                    <!-- 重点区域招商 -->
                    <div class="enterprise_list_box" style="padding-top: 20px;">
                        <!-- 龙头  优质 上市 创新通用表格 -->
                        <div class="enterprise_list_box" v-show="enterpristlist.length != 0">
                            <table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
                                <tr>
                                    <th>企业名称</th>
                                    <th>经营状况</th>
                                    <th>企业战略态势</th>
                                    <th>企业核心产品/概念</th>
                                    <th>企业选址逻辑</th>
                                    <th>企业概念</th>
                                </tr>
                                <tr v-for="(list, index) in enterpristlist" :key="index">
                                    <td class="title"
                                        @click="routerlinkid('/enterprises', list.stockCode, 9, '', curindex)">
                                        {{ list.title }}</td>
                                    <td>{{ list.operateText || '-' }}</td>
                                    <td>{{ list.strategyText || '-' }}</td>
                                    <td class="text-left">
                                        <el-tag class="mr-1 mb-1" effect="plain" v-for="(item, i) in list.productListArray" :key="i">{{ item }}</el-tag>
                                    </td>
                                    <td class="text-left">
                                        <el-tag class="mr-1 mb-1" v-for="item in list.siteList" :key="item.type"
                                            effect="plain">
                                            {{ item.name }}
                                        </el-tag>
                                        <!-- <span class="span-tag" v-for="item in list.siteList" :key="item.type">{{item.name}}</span> -->
                                    </td>
                                    <td class="conpanytags">
                                        <span class="span-tag" v-for="item in list.notionlist" :key="item.id"
                                            @click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'all')">{{ item.name }}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <!-- 表格内容结束 -->
                    <div class="centerpage1 company_pagelist nojump" v-show="totalPage > 1">
                        <zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
                            v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
                        </zpagenav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
    name: 'enterpriseSiteSelection',
    computed: {
        ...mapState({
            isCollapse: (state) => state.isCollapse,
        }),
        ...mapGetters(['isCollapse'])
    },
    data() {
        return {
            isShowFreeUserTips: false,
            title: "企业选址逻辑",
            total1: 0,
            userdata: {}, curWebsite: this.$api.getWebsiteType(),
            strategyList: [
                { name: '扩张期', type: 1 },
                { name: '稳定期', type: 2 },
                { name: '收缩期', type: 3 },
                { name: '转型期', type: 4 },
                { name: '扩张放缓期', type: 5 }
            ],
            strategy: '',
            siteList: [
                { name: '资源-原料导向', type: 1 },
                { name: '要素成本导向', type: 2 },
                { name: '产业集群导向', type: 3 },
                { name: '市场-客户导向', type: 4 },
                { name: '特殊区位-政策导向', type: 5 },
                { name: '风险规避-供应链韧性导向', type: 6 }
            ],
            site: '',
            operateList: [
                { name: '经营稳健', type: 1 },
                { name: '增长停滞', type: 2 },
                { name: '业绩下滑', type: 3 },
            ],
            operate: '',
            enterpristlist: [],
            page: 1,  //显示的是哪一页
            haspage: true,//是否还有下一页
            pageSize: 10, //每一页显示的数据条数
            total: 100, //记录总数 
            totalPage: 1,
            maxPage: 10,  //最大页数  
        }
    },
    created() {
        this.$nextTick(() => {
            // 禁用右键
            document.oncontextmenu = new Function("event.returnValue=false");
            // 禁用选择
            document.onselectstart = new Function("event.returnValue=false");
        });
        this.userdata = this.getuseriformation();

        this.getCompanylist();
    },
    mounted() {

    },
    methods: {
        fillter(value, type) {
            switch (type) {
                case 'strategy':
                    this.strategy = value;
                    break;
                case 'site':
                    this.site = value;
                    break;
                case 'operate':
                    this.operate = value;
                    break;
            }
            this.getCompanylist();
        },
        //获取产业链/区域/融资企业招商线索
        getCompanylist(paged) {
            this.bus.$emit('loading', true);
            this.page = paged ? paged : 1;
            var _this = this;
            //获取企业列表
            var strategyja = this.splicing('strategy', this.strategy);
            var siteja = this.splicing('site', this.site);
            var operateja = this.splicing('operate', this.operate);
            var ajaxurl = this.$api.cyl.investclue.site() + '?page=' + this.page + strategyja + siteja + operateja;
            // console.log(ajaxurl);
            this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                }
            }).then(function (res) {
                // console.log('省份城市列表',res.data)
                if (res.data.success) {

                    console.log(ajaxurl, '获取热门排行榜企业列表', res.data);
                    _this.enterpristlist = res.data.list;
                    for (var i = 0; i < res.data.list.length; i++) {
                        _this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this.enterpristlist[i].tagCode);
                        _this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion, _this.enterpristlist[i].notionCode, 'notionsort');
                        _this.enterpristlist[i].siteList = _this.taglistfun(_this.enterpristlist[i].siteText, _this.enterpristlist[i].site);
                        _this.enterpristlist[i].productListArray = _this.extractProducts(_this.enterpristlist[i].productList);
                    }
                    console.log(_this.enterpristlist);
                    _this.totalPage = res.data.totalPage;
                    _this.pageSize = res.data.pageSize;
                    // _this.total = res.data.totalRecord;
                    // _this.haspage = res.data.list.length == res.data.pageSize;
                    _this.bus.$emit('loading', false);
                } else {

                }
            }).catch(function (error) {
                // 请求失败处理 console.log(error);
            });
        },
        pageHandler: function (page) {
            this.getcompanylist(page);
        },
        extractProducts(productListStr) {
            let product = productListStr.match(/[^：：]+$/gm);
            return product;
        },
    },
}
</script>

<style>
/* 提示框箭头 */
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
    border-top-color: #E0E8F9;
}

.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
    border-top-color: #E0E8F9;
}

/* 提示框背景色 */
.atooltip {
    background: #E0E8F9 !important;
}


.a-red {
    color: #c00;
}

.nojump .jump {
    display: none;
}
</style>